// extracted by mini-css-extract-plugin
export default {"container":"generate-qrcode-button_container__zrXDX","icon":"generate-qrcode-button_icon__TZ-5W"};